export default {
  getCalls: ({ calls }) => {
    return calls.map(({ callStart, duration }) => {
      return {
        callStart,
        durationStr: Math.ceil(duration / 60)
      };
    });
  },
  getProject: ({ project }) => project,
  getUser: ({ user }) => user,
  getMessage: ({ message }) => message,
  getLoadingPage: ({ loadingPage }) => loadingPage,
  getAccountBalance: ({ accountBalance }) => accountBalance,
  getWeekStats: ({ weekStats }) => weekStats
};
